import * as types from "./types";

export const fetchMifirTransactionsNotSubmittedReportDates = () => {
  return (api) => ({
    type: types.FETCH_MIFIR_TRANSACTIONS_NOT_SUBMITTED_REPORT_DATES,
    payload: api.get("v1/mifir/transactions-not-submitted/report-dates"),
  });
};

export const fetchMifirPendingTradingPlatforms = (reportDate) => {
  return (api) => ({
    type: types.FETCH_MIFIR_PENDING_TRADING_PLATFORMS,
    payload: api.get(`v1/mifir/transactions-not-submitted/platforms?report_date=${encodeURIComponent(reportDate)}`),
  });
};

export const fetchMifirTransactionsNotSubmitted = (reportDate, tradingPlatform) => {
  return (api) => ({
    type: types.FETCH_MIFIR_TRANSACTIONS_NOT_SUBMITTED,
    payload: api.get(
      `v1/mifir/transactions-not-submitted?report_date=${encodeURIComponent(reportDate)}&trading_platform=${encodeURIComponent(tradingPlatform)}`
    ),
  });
};

export const prepareMifirReport = (reportDate, tradingPlatform, forceReprepare = false, reprepareReason = "") => {
  return (api) => ({
    type: types.PREPARE_MIFIR_REPORT,
    payload: api.post("v1/mifir/prepare", {
      reportDate,
      tradingPlatform,
      forceReprepare,
      reprepareReason,
    }),
    hideUserErrors: true,
  });
};

export const fetchMifirFeedbackReportDates = () => {
  return (api) => ({
    type: types.FETCH_MIFIR_FEEDBACK_REPORT_DATES,
    payload: api.get("v1/mifir/feedback/report-dates"),
  });
};

export const fetchMifirFeedbackResponses = (from, to) => {
  return (api) => ({
    type: types.FETCH_MIFIR_FEEDBACK_RESPONSES,
    payload: api.get(`v1/mifir/feedback/responses?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),
  });
};

export const fetchMifirFeedback = (from, to, response = "ALL") => {
  return (api) => ({
    type: types.FETCH_MIFIR_FEEDBACK,
    payload: api.get(
      `v1/mifir/feedback?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&response=${encodeURIComponent(response || "ALL")}`
    ),
  });
};


export const fetchMifirErrorTypes = (from, to) => {
  return (api) => ({
    type: types.FETCH_MIFIR_ERROR_TYPES,
    payload: api.get(`v1/mifir/errors/types?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),
  });
};

export const fetchMifirErrors = (from, to, errorType = "ALL") => {
  return (api) => ({
    type: types.FETCH_MIFIR_ERRORS,
    payload: api.get(
      `v1/mifir/errors?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&error_type=${encodeURIComponent(errorType || "ALL")}`
    ),
  });
};

export const fetchMifirSubmissions = () => {
  return (api) => ({
    type: types.FETCH_MIFIR_SUBMISSIONS,
    payload: api.get("v1/mifir/submissions"),
  });
};

export const submitMifirReport = (cysecUsername, cysecPassword, confirmErrors = false) => {
  return (api) => ({
    type: types.SUBMIT_MIFIR_REPORT,
    payload: api.post("v1/mifir/submit", {
      cysecUsername,
      cysecPassword,
      confirmErrors,
    }),
    hideUserErrors: true,
  });
};

export const receiveMifirFeedback = (cysecUsername, cysecPassword) => {
  return (api) => ({
    type: types.RECEIVE_MIFIR_FEEDBACK,
    payload: api.post("v1/mifir/receive-feedback", {
      cysecUsername,
      cysecPassword,
    }),
    hideUserErrors: true,
  });
};

export const fetchMifirActiveProcess = () => {
  return (api) => ({
    type: types.FETCH_MIFIR_ACTIVE_PROCESS,
    payload: api.get(`v1/mifir/processes/active?_=${Date.now()}`),
  });
};

export const fetchMifirProcessHistory = (options = {}) => {
  const normalized = typeof options === "number" ? { pageSize: options } : (options || {});
  const page = Math.max(1, Number(normalized.page) || 1);
  const pageSize = Math.max(1, Number(normalized.pageSize) || 25);
  const query = [
    `page=${encodeURIComponent(page)}`,
    `pageSize=${encodeURIComponent(pageSize)}`,
  ];

  if (normalized.startDate) query.push(`startDate=${encodeURIComponent(normalized.startDate)}`);
  if (normalized.endDate) query.push(`endDate=${encodeURIComponent(normalized.endDate)}`);
  if (normalized.processType && normalized.processType !== "ALL") {
    query.push(`processType=${encodeURIComponent(normalized.processType)}`);
  }
  if (normalized.tradingPlatform && normalized.tradingPlatform !== "ALL") {
    query.push(`tradingPlatform=${encodeURIComponent(normalized.tradingPlatform)}`);
  }
  if (normalized.status && normalized.status !== "ALL") {
    query.push(`status=${encodeURIComponent(normalized.status)}`);
  }

  query.push(`_=${Date.now()}`);

  return (api) => ({
    type: types.FETCH_MIFIR_PROCESS_HISTORY,
    payload: api.get(`v1/mifir/processes?${query.join("&")}`),
  });
};
